import styled from "styled-components";


import Colors from "../../../../constants/Colors";
import { Button } from "../../../company/companyRegister/CompanyRegister.styled";

interface TextProps {
  color?: string;
  bold?: boolean;
  textAlign?: string;
}

export const Container = styled.div<{ isMobile?: boolean }>``;

export const GeneralContainer = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;

export const TextLink = styled.a<{
  color?: string;
  bold?: boolean;
  disabled?: boolean;
}>`
  word-break: break-word;
  color: ${props =>
    props.disabled ? "#939393" : props.color ? props.color : "#575757"};
  font-size: 14px;
  font-weight: ${props => (props.bold ? "bold" : "")};
  font-family: "Inter", sans-serif;
  cursor: ${props => (props.disabled ? "auto" : "pointer")};
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const BoxAttendance = styled.div`
  width: 90%;
  height: 250px;
  border: 1px solid ${Colors.GRAY200};
  border-radius: 10px;
  padding-left: 20px;
  padding-top: 10px;

  overflow-y: auto;
`;
export const BoxSelect = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  height: 25px;
  /* border: 1px solid red; */
`;
export const Box = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media screen and (max-width: 940px) {
    width: 55%;
  }
  @media screen and (max-width: 760px) {
    flex-direction: column;
    align-items: flex-start;
  }
  margin-bottom: 20px;
`;
export const Subtitle = styled.p`
  height: 20px;
  margin-top: -13px;
  font-family: "Inter", sans-serif;
  /* border: 1px solid red; */
`;
export const OptionSelect = styled.p`
  height: 20px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;
export const CheckBox = styled.input`
  width: 20px;
  height: 20px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

export const Topic = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  /* padding: 16px; */
  padding-left: 20px;
  gap: 16px;

  width: 90%;
  height: 56px;

  background: ${Colors.SPM50};
  border-radius: 8px;
  margin-top: 30px;
`;
export const Name = styled.p`
  min-width: 69px;
  height: 24px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;

  letter-spacing: -0.02em;

  color: ${Colors.GRAY1000};
`;
export const P = styled.p``;
export const MediumInput = styled.textarea`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 14px;
  gap: 8px;
  width: 100%;
  height: 96px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  resize: none;
`;
export const ContentTopic = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-left: 30px;
  width: 80%;
`;

export const AddButton = styled(Button)`
  font-family: "Inter", sans-serif;
  margin-top: 15px;
`;

export const BoxAtendimentoFinalizado = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 16px 24px;
  width: 87%;
  height: 156px;
  background: #f8fafc;
  border-radius: 8px;
  flex: none;
  order: 0;
  flex-grow: 0;

  @media screen and (max-width: 760px) {
    width: 85%;
    flex-direction: column;
    align-items: flex-start;
  }
  margin-bottom: 20px;
`;
